/* eslint-disable import/prefer-default-export */
export const FACILITIES_NEARBY_LIMIT = 3;
